<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0"> Selecciona el parking que mejor se ajusta a tus intereses</p>
      </CCol>
    </CRow>


    <CCard>
      <CCardBody borderColor="primary">
        <h5 class="subtitle mb-1">2. Selecciona el parking</h5>
        <p class="mb-3 text-primary">Elije un parking para ver las tarifas disponiples</p>

        <CForm @submit.prevent data-vv-scope="new-delivery">

          <CRow>
            <CCol sm="12">
              <label class="required" for="pickup_address"><strong>Selecciona el parking:</strong></label>

              <multiselect
                v-model="product.parkings_id"
                :options="parkings"
                :class="{'error': errorParking }"
                label="label"
                track-by="label"
                placeholder="Escribe para buscar"
                class="select-tags"
                :loading="loading"
                :searchable="true"
                :options-limit="300"
                :max-height="600"
                :multiple="false"
                deselectLabel="Pulsa Enter para eliminar"
                selectedLabel="Seleccionado"
                selectLabel="Pulsa Enter para seleccionar"
                :showNoResults="true"
              >
                <span slot="noResult"
                  >No hay resultados con ese texto. Considera cambiar el
                  texto.</span
                >
                <span slot="noOptions">Lista vacía</span>
              </multiselect>


            <p class="error-field" v-if="errorParking">
              <span>Debes seleccionar un parking</span>
            </p>

            </CCol>

          </CRow>


        </CForm>

        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery" class="btn-login-custom btn" >
        Siguiente
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"

import { createDelivery, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";
import { fetchAllParkings } from "@/app/shared/global/services/global-service";



export default {
  name: "ContractParking",
  components: {

  },
  data() {
    return {
      step: 2,
      elemento: "Parkings disponibles",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null,
        parkings_id: null
      },

      contractPlanApi: null,

      errorParking: false,

      parkings: [],

    };
  },
  created() {


  },
  async mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      await this.setDataLocalStorage();
    }

    this.getAllParkings();

  },

  methods: {

    async getAllParkings() {

      try {

        let filtro = '';

        if (this.product.towns_id) {
          filtro = `&towns_id=${this.product.towns_id}`;
        }

        const resp = await fetchAllParkings(filtro); // sin paginación

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(`Error al obtener los parkings`, null, 'error', '2000');
          return;
        }

        let data = [...resp.data];

        data.forEach((p) => {
          this.parkings.push({
            label: p.name,
            value: p.id,
          });
        });

        this.parkings = this.parkings.filter(
          (town, index, self) =>
            index === self.findIndex((t) => t.label === town.label)
        );

      } catch (err) {
        this.$refs.toast.showToast(`Error al obtener los parkings`, null, 'error', '2000');
      } finally {
        this.loading = false;
      }
    },

    saveDelivery() {

      this.$validator.validateAll('new-delivery').then( async (valid) => {

        if (valid ) {

          this.loading = true;
          const errorMessage = `Se ha producido un error al calcular el envío`;

          try {

            const contractToSave = {
              ...this.product,
              parkings_id: this.product.parkings_id.value,
            }


            // const resp = await createDelivery(contractToSave);

            // if (resp?.status !== 'success') {
            //   this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');
            //   return
            // }

            // this.contractPlanApi = resp.data;

            this.contractPlanApi = {...contractToSave};



            this.nextStep();

          } catch (e) {
  
            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');

          } finally {
            this.loading = false;
          }

        } else {
          this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
          // this.message = 'Debes completar las direcciones de recogida y entrega para crear un nuevo envío';
        }
      })
    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          this.product = {
            ...storedData,
            towns_id: storedData.towns_id
          };

        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.contractPlanApi);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      // const data = { valid: true, parkingId: this.contractPlanApi.parkings_id }

      this.$emit("validForm", { valid: true, parkingId: this.contractPlanApi.parkings_id } );
      this.loading = false;



    },



    formatDataSelect(ad) {

      if (ad) {
        const label = ad.store ? `${ad.alias} - ${ad.address}` : ad.address

        return {
          label: label, //`${ad.alias} - ${ad.address}`,
          value: ad.id
        }
      }
    },






  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
